// src/components/CustomButton
import { useContext } from "react";
import classes from "./CustomButton.module.css";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../utils/DataContext";
import { UserAuth } from "../utils/AuthContext";
import { resolveIcon } from "../utils/resolveIcon";
import { useLocation } from "react-router-dom";


export default function BackToDashboard({
  elementType,
  title,
  icon,
  iconSize,
  variant,
  minWidth,
  reverseIcon,
  disabled,
  to,
  ...props
}) {
  const Element = elementType ? elementType : "button";
  const { setError } = useContext(DataContext);
  const { userData } = useContext(UserAuth);

  const navigate = useNavigate();

  const routerLocation = useLocation();
  const pathParts = routerLocation.pathname.split("/").filter(Boolean);


  const navigateFunction = () => {
    setError("");
    if (userData?.userType === "superadmin" || userData?.userType === "admin") {
      navigate(to || -1);
      return;
    }
    switch (userData?.organizationType) {
      case "CLINIC":
      case "PHARMACY":
      case "MERCHANT":
      case "NO_CUSTOMER_MERCHANT":
      case "SUPERMARKET":
      case "FABRICSTORE":
      case "PAPERFACTORY":
      case "SCHOOL":
      case "BANK":
      case "SQUAD":
        navigate(to || -1);
        break;
      default:
        navigate(to || "/invoiceManagement");
        break;
    }
  };
  const iconSrc = resolveIcon(icon);

  // if (pathParts.length === 1) {
  //   return null;
  // }

  return (
    <Element
      className={`${classes.customButton} ${variant ? classes[variant] : ""} ${
        disabled ? classes.disabled : ""
      }`}
      style={{
        minWidth: minWidth || "",
        pointerEvents: disabled ? "none" : "auto",
        opacity: disabled ? 0.5 : 1,
      }}
      disabled={Element === "button" ? disabled : undefined}
      onClick={navigateFunction}
      {...props}
    >
      {!reverseIcon && icon && (
        <img
          src={iconSrc}
          alt={title}
          style={{ width: iconSize + "px" }}
          className={classes.icon}
        />
      )}
      <span className={classes.title}>{title}</span>
      {reverseIcon && icon && (
        <img
          src={iconSrc}
          alt={title}
          style={{ width: iconSize + "px" }}
          className={classes.icon}
        />
      )}
    </Element>
  );
}
